import * as React from 'react';

const QuickReplies24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M20.75 5.504v8.639a.691.691 0 0 1-.6.685L2.4 17.202a.75.75 0 1 0 .2 1.487l17.75-2.375a2.191 2.191 0 0 0 1.9-2.171v-8.69a2.191 2.191 0 0 0-2.48-2.172L6.855 5a2.191 2.191 0 0 0-1.902 2.172v4.536a.75.75 0 0 0 1.5 0V7.741l5.31 4.491a2.184 2.184 0 0 0 3.024-.195l5.963-6.533ZM7.261 6.46l12.05-1.605-5.632 6.17a.684.684 0 0 1-.947.062L7.262 6.46Zm.603 7.62a.75.75 0 0 1-.644.843l-.5.066-1.208.132-.973.13-.362.048a.75.75 0 0 1-.196-1.487l.36-.048.99-.132L6.54 13.5l.482-.064a.75.75 0 0 1 .843.644Zm6.901 5.014a.75.75 0 0 1-.644.843l-5.949.795a.75.75 0 0 1-.199-1.487l5.95-.795a.75.75 0 0 1 .842.644Z"
  }
));
QuickReplies24.Size = 24;
QuickReplies24.Title = "QuickReplies";

export { QuickReplies24 as default };
